'use strict';

/*global app*/
/*global services*/
/*global BasicItemForm*/
/*global createObjectCallBack*/
/*global parseFloatK2*/
/*global formatAmountByUnit*/
/*global getAmountToUnit*/
/*global getUnitByUnit*/
/*global resSuccess*/

function ItemMismatchProcessingForm() {
  BasicItemForm.call(this, 'item-form--mismatch-processing');

  this.isAmountNotFound = false;

  this.init();
}

ItemMismatchProcessingForm.prototype = $.extend({}, BasicItemForm.prototype, {
  constructor: 'ItemMismatchProcessingForm',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.' + _this.formClass + ' .item-form__release-from-another-location', function () {
      _this.releaseFromAnotherLocation();

      return false;
    });

    $('body').on('click', '.' + _this.formClass + ' .item-form__amount-not-found', function () {
      _this.amountNotFound();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  amountNotFound: function amountNotFound() {
    var _this = this;

    _this.isAmountNotFound = true;
    _this.save();

    return _this;
  },

  getLocations: function getLocations() {
    var _this = this;

    var locations = [];
    _this.confirm.contentDOM().find('.item-form__another-location').each(function () {
      var $location = $(this);
      locations.push({
        locationId: $location.find('[name^="another_location_location_id"]').val(),
        amount: parseFloatK2($location.find('[name^="another_location_amount"]').val())
      });
    });

    return locations;
  },

  createNewAnotherLocation: function createNewAnotherLocation(location, amount) {
    var _this = this;

    var html = '';
    html += '<tr class="item-form__another-location">';
    html +=   '<td>';
    html +=     location.Location;
    html +=     '<input type="hidden" name="another_location_location_id[]" value="' + location.LocationId + '" />';
    html +=   '</td>';
    html +=   '<td>';
    html +=     formatAmountByUnit(amount, _this.data.Unit) + ' ' + _this.data.Unit;
    html +=     '<input type="hidden" name="another_location_amount[]" value="' + amount + '" />';
    html +=   '</td>';
    html += '</tr>';

    return $(html);
  },

  checkAnotherLocationsAmount: function checkAnotherLocationsAmount(newAmount) {
    var _this = this;

    var amount = newAmount;
    $.each(_this.getLocations(), function (key, location) {
      amount += location.amount;
    });

    return amount <= _this.data.AmountMismatch;
  },

  releaseFromAnotherLocation: function releaseFromAnotherLocation() {
    var _this = this;

    //nacteme umisteni
    _this.locationService.scanLocation({ StockId: _this.data.StockId }, function (res, resData) {
      if (res === resSuccess && resData.LocationId) {
        //zadame mnozstvi
        _this.inputService.getValue({ title: app.t('item_form.insert_amount'), suffix: getUnitByUnit(_this.data.Unit) }, function (value) {
          var amount = getAmountToUnit(value, _this.data.Unit);
          if (_this.checkAnotherLocationsAmount(amount)) {
            var $location = _this.createNewAnotherLocation(resData, amount);
            var $anotherLocations = _this.confirm.contentDOM().find('.item-form__another-locations');
            var $anotherLocationsContainer = $anotherLocations.find('.item-form__another-locations-container');

            $anotherLocations.show();
            $anotherLocationsContainer.append($location);
          } else {
            app.viewErrorMessage(app.t('item_mismatch_processing_form.new_amount_is_higher'));
          }
        });
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  initForm: function initForm(data) {
    var _this = this;

    _this.initFormBasic(data);

    return _this;
  },

  isFormValid: function isFormValid() {
    //var _this = this;

    var res = true;

    //if (_this.data.MismatchId === app.param('high_amount_mismatch_id')) {
    //  res = true;
    //}

    return res;
  },

  doSave: function doSave() {
    var _this = this;

    var result = {};
    var data = _this.origData;
    data.locations = _this.getLocations();
    data.isAmountNotFound = _this.isAmountNotFound ? 1 : 0;

    _this.confirm.block();
    $.post(app.path('item_mismatch_processing_form_process'), data, function (res) {
      _this.confirm.unBlock();

      if (res.msg === 'SUCCESS') {
        if (_this.settings.saveCallBack) {
          _this.settings.saveCallBack(result);
        }

        _this.confirm.close();
      } else {
        app.viewErrorMessage();
        _this.confirm.close();
      }
    });

    return _this;
  },

  open: function open(settings, data) {
    var _this = this;

    //pokud uz ted nejsme online, tak konec
    if (!app.internetConnectionManager.isOnline()) {
      app.internetConnectionManager.viewOfflineWarning();
      return _this;
    }

    _this.settings = $.extend({}, _this.defaultSetting, settings);
    _this.origData = data;
    _this.confirm.open({
      title: app.t('item_form.title'),
      confirmCallBack: createObjectCallBack(_this, 'save'),
      confirmBtnTitle: app.t('item_form.confirm_form'),
      rejectCallBack: createObjectCallBack(_this, 'cancel'),
      rejectBtnTitle: app.t('item_form.reject_form'),
      modalClass: _this.modalClass,
      width: 'md',
      buttonsSize: 'lg',
      focusInput: false,
      content: ''
    });

    _this.confirm.block();

    //asi by chtelo nějak pořešit toto
    $.get(app.path('item_mismatch_processing_form'), data, function (res) {
      _this.confirm.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.initForm(res.data);
      } else {
        app.viewErrorMessage();
        _this.confirm.close();
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.defaultSetting = {
      saveCallBack: null
    };

    _this.confirm = services.get('item-form-confirm');
    _this.registerCallbacks();

    return _this;
  }
});
